export default "__VITE_ASSET__DdgL1Lmb__"